/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CountryApi } from '../api/countriesMst.api';
import { switchMap, map } from 'rxjs/operators';
import { CountryData, CountryMst } from '../../../interfaces/masters/country';

@Injectable()
export class CountryMstService extends CountryData {

  constructor(private api: CountryApi) {
    super();
  }


  list(): Observable<CountryMst[]> {
    return this.api.list();
  }

  getById(url:string): Observable<CountryMst>{
      return this.api.getById(url);
  }

  create(url: string, data:CountryMst): Observable<CountryMst> {
    return this.api.add(url,data);
  }

  update(url: string, data:CountryMst): Observable<CountryMst> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
